import * as types from './actionTypes';

const initialState = {
  multilevel_approvals: null,
  loading: false,
  error: null,
  success: false,
};

const multilevelApprovalReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_MULTILEVEL_APPROVAL_REQUEST:
    case types.SAVE_MULTILEVEL_APPROVAL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case types.FETCH_MULTILEVEL_APPROVAL_SUCCESS:
      return {
        ...state,
        multilevel_approvals: action.payload?.data,
        loading: false,
        success: false,
      };

    case types.SAVE_MULTILEVEL_APPROVAL_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case types.FETCH_MULTILEVEL_APPROVAL_FAILURE:
    case types.SAVE_MULTILEVEL_APPROVAL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    case types.TOGGLE_APPROVAL_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };
    
    case types.TOGGLE_APPROVAL_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    
    case types.TOGGLE_APPROVAL_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    default:
      return state;
  }
};

export default multilevelApprovalReducer;
